import { AppRouter } from "@/zapi-admin/app/providers/router";

export function App() {
  return <AppRouter />;
}

export default App;
